import { getCookie } from 'cookies-next';

export const isAppWithNativeHeader = (): boolean => {
  const nativeHeaderHeight = getCookie('native_header_height');
  return !!nativeHeaderHeight;
};

